import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useImmer } from "use-immer";
import useObtenerSubsecciones from "../js/translations/useObtenerSubsecciones";
import { DemoCleverAPI } from "../services/api/DemoClever";

/**
 * Este componente tiene toda la lógica para mostrar el formulario de demo, actualmente se usa para mostrase solo a Clever, desde Application.js 
 */
export const DemoPopUp = () => {
    const {textosSubSecciones:textos} = useObtenerSubsecciones('popup_demo');
    const [showPopup, setShowPopup] = useState(null);
    const [showForm, setShowForm] = useState(true);
    const [formData, setFormData] = useImmer({
        fullName:'',
        email:'',
        message:''
    })
    const [fetching, setFetching] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const initialFormInputRef = useRef(null);
    const openModalButtonRef = useRef(null);

    const onSubmit = async()=>{
        if(fetching) return;
        setFetching(true);
        await DemoCleverAPI.solicitarDemo({abortSignal:null, data:formData})
        .then(result=>{
            setFetching(false);
            setShowConfirmation(true);
            setShowForm(false);
        })
        .catch(error=>console.log(error))
    }

    const openPopUp = ()=>{
        setShowPopup(true);
        setShowForm(true);
        setShowConfirmation(false);
        setFormData(draft=>{
            draft.email = '';
            draft.fullName = '';
            draft.message = '';
        })
        if(initialFormInputRef.current){
            initialFormInputRef.current.focus();
        }
    }

    useEffect(()=>{
        if(!showPopup&&openModalButtonRef.current){
            openModalButtonRef.current.focus();
        }
        if(showPopup&&initialFormInputRef.current){
            initialFormInputRef.current.focus();
        }
    },[showPopup, openModalButtonRef, initialFormInputRef])


    return (<>
        <div  role={'alertdialog'} aria-modal={"true"} className={`focusable-red demo-popup-backdrop ${showPopup?'visible':showPopup!==null&&'hidden'}`} id="demo-popup-backdrop">
            <div className="demo-popup-window">
                <button className="demo-popup-close-button focusable-red" onClick={()=>setShowPopup(false)}>
                    <div className="icon"></div>
                </button>
                <div className="demo-popup-content">
                    <section className={`demo-popup-confirmation-view ${showConfirmation&&!showForm?'visible':'hidden'}`}>
                        <img className="logo" src="/img/demo-popup/submitted.png" alt="" />
                        <h2 className="title">{textos?.confirmacion?.titulo || 'Submitted!'}</h2>
                        <p className="description">{textos?.confirmacion?.descripcion || 'Thanks! We will contact you soon.'}</p>
                        <button className="button focusable-red" onClick={()=>setShowPopup(false)}>{textos?.confirmacion?.boton || 'Ok'}</button> 
                    </section>
                    <section className={`demo-popup-form-view ${!showConfirmation&&showForm?"visible":"hidden"}`} id="demo-popup-form-view">
                        <h3 className="demo-popup-title" dangerouslySetInnerHTML={{__html:`${textos?.formulario?.titulo || ' Do you want a full<br />demo for your school?'}`}}>
                        </h3>
                        <img className="demo-popup-logo" src="/img/demo-popup/logo.png" alt="" />
                        <form className="demo-popup-form" action="" autocomplete="off" onSubmit={(e)=>{e.preventDefault();onSubmit()}}>
                            <fieldset>
                                <input
                                    ref={initialFormInputRef}
                                    className="focusable-red"
                                    type="text"
                                    id="demo-popup-name"
                                    name="name"
                                    placeholder={textos?.formulario?.input?.nombre?.placeholder || 'Your name'}
                                    required
                                    value={formData.fullName}
                                    onChange={(e)=>{
                                        e.persist();
                                        setFormData(draft=>{draft.fullName=e.target.value || ''});
                                    }}
                                />
                                <label for="demo-popup-name">{textos?.formulario?.input?.nombre?.label || 'Full name'}</label>
                            </fieldset>
                            <fieldset>
                                <input
                                    className="focusable-red"
                                    type="email"
                                    id="demo-popup-email"
                                    name="email"
                                    placeholder={textos?.formulario?.input?.email?.placeholder || 'Your email'}
                                    required
                                    value={formData.email}
                                    onChange={(e)=>{
                                        e.persist();
                                        setFormData(draft=>{draft.email=e.target.value || ''});
                                    }}
                                />
                                <label for="demo-popup-email">{textos?.formulario?.input?.email?.label || 'Email'}</label>
                            </fieldset>
                            <fieldset>
                                <textarea
                                    className="focusable-red"
                                    type="email"
                                    id="demo-popup-message"
                                    name="message"
                                    placeholder={textos?.formulario?.input?.mensaje?.placeholder || 'Your message'}
                                    rows="3"
                                    required
                                    value={formData.message}
                                    onChange={(e)=>{
                                        e.persist();
                                        setFormData(draft=>{draft.message=e.target.value || ''});
                                    }}
                                ></textarea>
                                <label for="demo-popup-message">{textos?.formulario?.input?.mensaje?.label || 'Message'}</label>
                            </fieldset>
                            <button type="submit" className={`demo-popup-submit focusable-red ${fetching?'sending-form':''}`} id="demo-popup-submit">
                               {
                                !fetching?`${textos?.formulario?.boton?.nombre|| 'Please contact me! →'}`:`${textos?.formulario?.boton?.enviando|| 'Submitting...'}`
                               }
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
        <div className="demo-popup-open-card visible" id="demo-popup-open-card">
            <p className="title">{textos?.tarjeta_principal?.titulo || 'Request a full demo account'}</p>
            <button ref={openModalButtonRef} className="button focusable-red" onClick={()=>openPopUp()}>{textos?.tarjeta_principal?.boton || 'Please contact me! →'}</button>
            <img className="logo" src="/img/demo-popup/logo.png" alt="" />
        </div>

    </>)
}